import React, { useEffect } from 'react'

import CheckboxItem from 'components/input/checkbox-item'

import {
    getPriceAndSymbol
} from 'utils'

export default ({
    onChange,
    planAndCurrencyData,
    discountMonths,
    discountPercent,
    extraStorage,
    value
}) => {
    const types = [
        {
            label: 'Monthly',
            value: 'monthly'
        }, {
            label: 'Annually (Get 20% off!)',
            value: 'annually'
        }
    ]

    useEffect(() => {
        if (!value) {
            onChange(types[0].value)
        }
    }, [value])

    const {
        price,
        symbol
    } = getPriceAndSymbol(null, value === 'annually', planAndCurrencyData)

    const totalPricePerUser = symbol + price
    const totalPricePerUserWithDiscount = symbol + (discountPercent ? price * ((100 - discountPercent) / 100) : price).toFixed(2)

    return (
        <div className={'billing-type'}>
            <div className={'checkbox-row'}>
                {types.map(type => {
                    const {
                        label,
                        value: _value
                    } = type

                    return (
                        <div className={'input-wrap'} key={label}>
                            <CheckboxItem
                                label={label}
                                onChange={_ => onChange(_value)}
                                value={value === _value}
                            />
                        </div>
                    )
                })}
            </div>
            <React.Fragment>
                <div className={`info ${discountPercent ? 'has-discount' : ''}`}>
                    <figure>
                        {totalPricePerUser}
                    </figure>
                    {discountPercent &&
                        <figure>
                            {totalPricePerUserWithDiscount}
                        </figure>
                    }
                    <p>
                        Per team member, billed in 3 months.<br />
                        Cancel any time &amp; guests are 100% free.
                    </p>
                </div>
                <span className={'discount-info'}>
                    <i className={'fe fe-check'} />
                    {discountPercent ?
                        `Discount applied ${discountMonths ? `For ${discountMonths} months` : `permanently`} ${extraStorage ? `(with ${extraStorage}GB extra storage)` : ''}`
                        :
                        <React.Fragment>
                            Includes a <strong>90-day</strong> free trial.
                        </React.Fragment>
                    }
                </span>
            </React.Fragment>
        </div>
    )
}